import { type FC, type PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { useRbvcFeatureVisible } from './useRbvcFeatureVisible';
import type { RbvcFeatureId } from './features';

/**
 * Route guard that redirects to `/` when the role doesn't grant the
 * given RBVC feature. Frontend visibility only — bypassable by anyone
 * willing to call the API directly. Mirrors the sidebar / tab gating
 * so a deep-link or bookmark doesn't leak content the admin tried to
 * hide.
 *
 * Usage:
 *   <Route
 *     path="documents"
 *     element={
 *       <RequireRbvcFeature feature="documents">
 *         <DocumentsRoute />
 *       </RequireRbvcFeature>
 *     }
 *   />
 */
type Props = PropsWithChildren<{ feature: RbvcFeatureId }>;

export const RequireRbvcFeature: FC<Props> = ({ feature, children }) => {
  const visible = useRbvcFeatureVisible(feature);
  if (!visible) return <Navigate to="/" replace />;
  return <>{children}</>;
};
